<template>
  <div>
    <!--
    <button class="close-btn" @click="hideItemDetails">
      <b-icon icon="X" scale="2.0"></b-icon>
    </button>
    -->

    <div class="loader d-flex justify-content-center" v-if="item == null">
      <b-spinner :label="$t('common_phrases.loading')"></b-spinner>
    </div>
    <div class="detail-view" v-if="item != null">
      <!--{{JSON.stringify(this.item)}}-->
      <h4>{{name}}</h4>
      <b-row v-if="this.spatialData == null" class="no_spatial_info">
        <b-col><b-icon icon="exclamation-circle-fill" variant="warning"></b-icon>
        {{$t('map.warnings.location_lack')}}</b-col>
      </b-row>
      <b-row><b-col><label>{{$t('map.label.id')}}</label></b-col><b-col>{{item.tunnus}}</b-col></b-row>
      <b-row v-if="item.kuvaus"><b-col><label>{{$t('map.label.description')}}</label></b-col><b-col>{{item.kuvaus}}</b-col></b-row>
      <b-row><b-col><label>{{$t('map.label.organization')}}</label></b-col><b-col>{{item.organisaatio}}</b-col></b-row>
      <b-row><b-col><label>{{$t('map.route_tab.destinations')}}</label></b-col><b-col>{{this.destination}}</b-col></b-row>
      <b-row><b-col><label>{{$t('map.route_tab.route_vehicle_type')}}</label></b-col><b-col>{{this.routeVehicleType}}</b-col></b-row>

      <div v-if="this.routeStopData != null" class="stopList">
      <span class="routeStopTitle">{{$t('map.route_tab.routeStopsTitle')}}</span>
      <template v-for="(i) in this.routeStopData.routestops">
        <div :key="i.tunnus" class="stopEntry">
          <div class="stopNro">{{i.jarjestys}}</div><div><div class="stopName">{{i.nimi}}</div><div class="stopTunnus">{{i.tunnus}}</div></div>
        </div>
      </template>
      </div>

      <!--<b-row><b-col><label>Laituri</label></b-col><b-col>{{item.laituri}}</b-col></b-row>-->
      <p-button size="sm" outline @click="editRoute" v-b-tooltip :title="$t('map.buttons.edit_route')"><b-icon icon="gear-fill" scale="1.0"></b-icon></p-button>
    </div>
  </div>
</template>

<script>
import mapstore from '@/store/map/mapstore'
import timetable from '@/store/timetable/timetable'

export default {
  name: 'MapRouteDetails',
  components: {
  },
  data: function() {
    return {
      item: null,
      spatialData: null,
      routeStopData: null
    }
  },
  props: {
   // msg: String
    itemId: {type: String, default: null}
  },
  beforeCreate: function() {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule("mapstore" , mapstore);
    }
    if (!this.$store.state.timetable) {
      this.$store.registerModule("timetable" , timetable);
    }
  },
  watch: {
  },
  mounted() {
      this.$store.dispatch('mapstore/getRoutesForTable').then(
      (data) => {
        //debugger;
        var found = null;
        var $vm = this;
        found = data.find((i)=>{
          try{
            return i.tunnus == $vm.$props.itemId
          } catch(err) {/*typerä kääntäjä*/}
        });
        this.item = found;
        this.spatialData = {};
      },
      ()=>{ 
      /* error hanskaus */
      });

      this.$store.dispatch('timetable/getRouteStops', this.$props.itemId)
        .then(data => {
        this.routeStopData = data.data;
      });
  },
  computed: {
    name: function() {
      try {
        return this.item.nimi;
      } catch(err) {
        return "";
      }
    },
    destination: function() {
      var destinArray = new Array();
      try {
        if(this.item.destinations.length < 1)
          return "";

        this.item.destinations.forEach(d => {
          if(d.kielikoodi == 1)
            destinArray.push(d);
        });
        destinArray.sort((a,b) => {
          if(a.jarjestys < b.jarjestys)
            return -1;
          if(b.jarjestys < a.jarjestys)
            return 1;
          if(b.jarjestys == a.jarjestys)
            return 0;
        });
        var maaranpaat = new Array();
        destinArray.forEach(e => {maaranpaat.push(e.nimi)});
        var destString = maaranpaat.join(' - ');
        return destString;
      } catch(err) {
        return "";
      }
    },
    routeVehicleType: function() {
      return this.item.vehicleTyyppi;
    },
  },
  methods: {
    hideItemDetails: function() {
      this.$emit('hideItemDetails');
    },
    editRoute: function() {
      this.$router.push({ path: '/timetables/routes', query: { routeId: this.item.tunnus }});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'mapDetail.scss';

.stopList {
  padding-top: 2em;
  padding-bottom: 1em;
  max-height: 60vh;
  overflow: auto;
}

.stopEntry {
  display: flex;
  border-bottom: 1px solid #ccc;
}
.stopNro {
  font-style: oblique;
  font-weight: bold;
  width: 2em;
  align-self: center;
}
.stopName {
  font-size: 0.9em;
}

.routeStopTitle {
  color: #9A9A9A;
  font-size: 0.85em;
  margin-bottom: 0.5em;
}

.stopTunnus {
  font-size: 0.7em;
  color: grey;
  padding-left: 1em;
}
</style>
